const PRODUCTS = [
  {
    icon: "ti-briefcase",
    title: "PM Manager",
    blurb: "The delivery workbook that holds decisions so you don't have to relitigate every Tuesday.",
  },
  {
    icon: "ti-users",
    title: "CM Manager",
    blurb: "Change readiness, scored and visualised with instant stakeholder alignment metrics.",
  },
  {
    icon: "ti-chart-bar",
    title: "BI Manager",
    blurb: "DMAIC, right-sized for real practitioners who need speed over methodology bloat.",
  },
];

export default function ProductGrid() {
  return (
    <section
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 20,
        maxWidth: 960,
        margin: "0 auto 4rem",
        padding: "0 20px",
      }}
    >
      {PRODUCTS.map((p) => (
        <div
          key={p.title}
          className="glass-card hover-card"
          style={{
            padding: "1.75rem",
          }}
        >
          <i className={`ti ${p.icon}`} style={{ fontSize: 28, color: "var(--lilac-deep)" }} aria-hidden="true" />
          <p style={{ fontFamily: "var(--font-voice)", fontSize: 18, fontWeight: 600, color: "var(--navy)", margin: "14px 0 6px" }}>
            {p.title}
          </p>
          <p style={{ fontSize: 13, color: "var(--text-secondary)", margin: 0, lineHeight: 1.6 }}>{p.blurb}</p>
        </div>
      ))}
    </section>
  );
}

const PLANS = [
  {
    name: "Practitioner",
    tagline: "Your delivery toolkit for project, change and improvement work.",
    monthly: 59,
    annual: 549,
    features: [
      "Classify and right-size every initiative with CRISP tiering",
      "Manage delivery: WBS, Gantt, RAID register, stakeholders and governance",
      "Manage change: readiness assessment, scorecard, change plan and team responses",
      "Manage improvement: DMAIC lifecycle from Define to Control",
      "Recover at-risk initiatives with the RTG Planner",
      "Export artefacts: Charter, Change Plan, Status Pack, BI Report and more",
      "Portfolio view across all your active initiatives",
      "Quick Learning Guides, Emergency Playbook and 50 AI Coach prompts a month",
    ],
  },
  // Not for sale (claims ladder, 8 Oct 2026): no price, features or subtitle until it ships.
  { name: "Professional", comingSoon: true },
];

const PROFESSIONAL_WAITLIST_HREF = "mailto:hello@groundworktierup.com.au?subject=Professional%20waitlist";

